// Self Assign is a custom-body popup: SelfAssignBody owns its own submit
// (selfAssignJob after the Yes confirmation), so the framework-level submit is
// a no-op. Kept for POPUP registration symmetry.
export const api = {
  submit: async () => {},
};
